
<template>
  <!--test
  <div>
    <h2 class="content-heading">{{labelComponentTop[actualLanguage]}}</h2><i class="fa fa-cc-stripe fa-3x"></i>

    <div class="block">

        <div class="col-sm-6 col-md-offset-3">
          <div id="card-element">
            
          </div>
          <div class="error red center-align white-text">
              {{stripeValidationError}}
          </div>     
        </div>
        <button v-on:click="purchase()" class="btn btn-success" type="button">Procéder au paiement</button>
        <button v-on:click="loadStripe()" class="btn btn-success" type="button">Deload</button>
    </div>
  </div>
  -->

<div class="form-group">
 
  <div class="row">
    <div class="col-xs-9">
      <h4 class="font-w300 push-10">{{labelComponentTop[actualLanguage]}}</h4>
    </div>
    <div class="col-xs-3">
      <i class="fa fa-cc-stripe fa-2x"></i>
    </div>
  </div>
  
  <!-- 
  <div v-if="planTransactionData.transactionStatusCode==='100'">
    <div class="row">
      <div class="col-xs-12">
        <hr size="50">
            <div id="card-element"></div>
            <hr size="50">
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
            <div class="error red center-align white-text">
                {{stripeValidationError}}
            </div> 
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <button v-on:click="purchase()" class="btn btn-success" type="button">
            <spinner size="small" v-if="processingTransaction"></spinner>
            <span v-else>Payer</span>
        </button>
        {{transactionMessage}}
      </div>
    </div>
  </div>
  -->


  <div v-if="planTransactionData.transactionStatusCode==='999'">
    <div class="row">
      <div class="col-xs-12">
        <hr size="50">
            <h4  class="font-w200 text-center">{{PaymentSuccess[actualLanguage]}}</h4>
            <h6  class="font-w200 text-center">{{CloseThisWindow[actualLanguage]}}</h6>
        <hr size="50">
      </div>
    </div>
  </div>
  <div v-else>
    <div class="row">
      <div class="col-xs-12">
        <hr size="50">
            <div id="card-element"></div>
            <hr size="50">
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
            <div class="error red center-align white-text">
                {{stripeValidationError}}
            </div> 
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <button v-on:click="purchase()" class="btn btn-success" type="button">
            <spinner size="small" v-if="processingTransaction"></spinner>
            <span v-else>{{Pay[actualLanguage]}}</span>
        </button>
        {{transactionMessage}}
      </div>
    </div>
  </div>





</div>


</template>


<script>

import _ from 'underscore'
import {mapState, mapActions} from 'vuex'
import Spinner from '../../components/Spinner.vue'

export default {
  name: 'StripePaiement',
  //props: ['InvoiceData','displayFlag'],
  
  components: {
    Spinner
  },

  data() {
    return {
      stripe : null,
      card : null,
      processingTransaction: false,
      displayStripeElement : false,
      errorMessage : "",
      actualLanguage : "FR",
      labelComponentTop: {FR: 'Paiment par carte de crédit', EN: 'Payment with credit card'},
      PaymentSuccess: {FR: "Paiement réussi.", EN: 'Payment succeed.'},
      CloseThisWindow: {FR: "Fermez cette fenêtre avec le X.", EN: 'CLose this window with the X.'},
      Pay: {FR: "Payer", EN: 'Pay'},


      transactionMessage : "",
      cardNumberElement:null,
      cardExpiryElement:null,
      cardCVCElement:null,
      stripeValidationError:null

    }
  },


  computed: {
    ...mapState('sessionStore', ['planTransactionData']),
  },

  methods: {
  
  loadStripe(){
    this.displayFlag = false
  },

  createAndMountFormElements(){
      var elements = this.stripe.elements()
      var card = undefined

      var style = {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '20px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      }

      //RETRAIT STRIPE
      /*
      this.card = elements.create('card', {style: style, hidePostalCode:true})
      this.card.mount('#card-element');
      this.card.on("change", this.setValidationError)
      */

  },

  setValidationError(event){
    this.stripeValidationError = event.error ? event.error.message : "";
  },


  purchase(){

    var stripeResponse = null;
    var stripeTokenValue = 'None';
    this.processingTransaction = true
    
    stripeResponse = this.stripe.createToken(this.card).then(function(result) {
      if (result.error) {
        this.stripeValidationError = result.error.message;
        //console.log(result);
        //console.log('Card token create error');
      } else {
        //console.log('Card token created');
        return(result.token.id)
      }
    });



    stripeResponse.then(function(value,stripeTokenValue){
        stripeTokenValue = value;
       // console.log(stripeTokenValue);

        //Mettre le code de communication à l'API Ev Sens ici
        this.planTransactionData.cardToken = stripeTokenValue


        this.$store.dispatch('sessionStore/processSubscription', this.planTransactionData)
        .then((response) => {
          this.processingTransaction = false
          if(response.data.Code=='OK'){
            this.planTransactionData.transactionStatusCode='999'
            //this.planTransactionData.transactionStatusCode='000'
            
            this.$store.dispatch('sessionStore/refreshProfileData')
            }
          else {
            this.transactionMessage = "Transaction abordée, ré-essayer. / Transaction aborded, try again."
            //console.log(response);
          }


        })


    }.bind(this))




    }


  },

  beforemount(){
      var elements = this.stripe.elements()
      var card = undefined

      var style = {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '18px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      }

      ////RETRAIT STRIPE
      /*
      this.card = elements.create('card', {style: style, hidePostalCode:true})
      this.card.mount('#card-element');
      this.card.on("change", this.setValidationError)
      */
  },

  mounted() {
    //Voir Dashboard.vue pour voir le load de : 'https://js.stripe.com/v3/'

    //!!!! NE PAS OUBLIER DE MODIFIER AUSSI : ModifyStripePaiement !!!!
    
    //RETRAIT STRIPE
    /*
    this.stripe = Stripe(process.env.STRIPE_KEY)
    this.createAndMountFormElements()
    */

    //console.log('-----Plan Transaction Data-----')
    //console.log(this.planTransactionData)

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// StripePaiment.vue?01feaf1f